const divActionLogs = {
  update: 'Update',
  comments: 'Comment',
  update_at: 'updated '
};

export default divActionLogs;
